// extracted by mini-css-extract-plugin
export default {"centered":"CreateAccountSuccessModal-module__centered___15LKs","plane":"CreateAccountSuccessModal-module__plane___3iCrv","body":"CreateAccountSuccessModal-module__body___2_mgA"};